import React, { Fragment, memo, useEffect, useState } from 'react';

import { getLiteral } from 'utils/getLiteral';
import { SalesService } from 'services';
import SageSalesGraph from './components/SageSalesGraph';
import SageStatistics from './components/SageStatistics';
import { Text, Icon, useTheme } from '@Sage/hoi-poi-ui';

import './styles.scss';

const Content = memo(({ entityId, sageSolution, idEnvironment, idCurrency }) => {
    const [sales, setSales] = useState([]);
    const [error, setError] = useState('');

    const theme = useTheme();

    useEffect(() => {
        if (!entityId) return;
        SalesService.getSageSales(entityId)
            .then((res) => {
                let sales = res.map((item) => ({
                    id: item.id,
                    amount: item.total,
                    date: new Date(item.dateCreated),
                }));
                setSales(sales);
            })
            .catch((e) => {
                console.error(e);
                setError(getLiteral('error_generalerror'));
            });
    }, [entityId]);

    return (
        <div className="fm-widgets__sage-content">
            {error && (
                <div className="fm-widgets__sage-content-error">
                    <Icon name="warning" />
                    <Text
                        className="fm-widgets__sage-content-error__text"
                        color={theme.colors.utility.textSecondary}
                    >
                        {error}
                    </Text>
                </div>
            )}
            {!error > 0 && (
                <Fragment>
                    <SageSalesGraph sales={sales} sageSolution={sageSolution} />
                    <SageStatistics
                        sales={sales}
                        sageSolution={sageSolution}
                        idEnvironment={idEnvironment}
                        idCurrency={idCurrency}
                    />
                </Fragment>
            )}
        </div>
    );
});
export default Content;
